<script setup lang="ts">
export type LinePaddings = "xs" | "sm" | "md" | "lg" | "xl";

interface Props {
  padding?: LinePaddings;
  custom?: boolean;
}

withDefaults(defineProps<Props>(), {
  padding: "md",
  custom: false,
});
</script>

<template>
  <div
    class="bg-neutral200"
    :class="{
      'my-0': !custom && padding === 'xs',
      'my-1': !custom && padding === 'sm',
      'my-3': !custom && padding === 'md',
      'my-5': !custom && padding === 'lg',
      'my-6': !custom && padding === 'xl',
    }"
    style="height: 1px"
  />
</template>
